import React, { FC, HtmlHTMLAttributes, PropsWithChildren } from 'react'

import { cn } from '@/lib/utils'

export type TextVariants =
  | 'heading'
  | 'headingXl'
  | 'heading2Xl'
  | 'heading3Xl'
  | 'heading4Xl'
  | 'title'
  | 'titleAlt'
  | 'subtitle'
  | 'controlLabel'
  | 'label'
  | 'link'
  | 'paragraph'
  | 'paragraphMedium'
  | 'paragraphSmall'
  | 'paragraphHuge'
  | 'muted'

export type TextProps = {
  Element?: 'div' | 'p' | 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  variant?: TextVariants
} & HtmlHTMLAttributes<HTMLDivElement>

const variantStyles: Record<TextVariants, string> = {
  heading: cn('text-xl md:text-lg 2xl:text-2xl font-medium'),
  headingXl: cn('text-2xl sm:text-3xl font-medium'),
  heading2Xl: cn('text-3xl sm:text-4xl font-medium'),
  heading3Xl: cn('text-4xl sm:text-5xl font-medium'),
  heading4Xl: cn('text-5xl sm:text-6xl font-medium'),
  title: cn('text-lg sm:text-xl font-medium'),
  titleAlt: cn('text-md font-medium'),
  subtitle: cn('text-sm sm:text-base font-medium'),
  controlLabel: cn('text-sm font-semibold'),
  label: cn('text-sm 2xl:text-base font-medium'),
  paragraph: cn('text-base'),
  paragraphMedium: cn('text-base font-medium'),
  paragraphSmall: cn('text-sm font-medium'),
  paragraphHuge: cn('text-lg font-normal leading-8'),
  link: cn('text-sm font-medium'),
  muted: cn('text-sm font-normal text-gray-500'),
}

export const Text: FC<PropsWithChildren<TextProps>> = ({
  Element = 'div',
  children,
  variant,
  className,
  ...divProps
}) => {
  return (
    <Element
      {...{
        ...divProps,
        className: cn(
          variantStyles[(variant as TextVariants) || 'paragraph'],
          className,
        ),
      }}
    >
      {children}
    </Element>
  )
}
